import React from 'react';
import ImagemAmex from 'assets/img/icones/icon-amex.png';

const LogoAmex = props => {
  return (<img src={ImagemAmex} width="100" heigth="56" alt="Amex" />)
};
export default LogoAmex;